"use strict";

var _excluded = ["plugins"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var React = require('react');

var SalWrapper = require('./SalWrapper')["default"];

exports.wrapPageElement = function (_ref, _ref2) {
  var element = _ref.element,
      props = _ref.props;

  var plugins = _ref2.plugins,
      options = _objectWithoutProperties(_ref2, _excluded);

  return options.sal ? /*#__PURE__*/React.createElement(SalWrapper, {
    options: options.sal,
    path: props.path
  }, element) : element;
};